import produce from 'immer';
import * as modalActionTypes from '../../constants/actionTypes/modals';
import * as canvasBlocksActionTypes from '../../constants/actionTypes/canvasBlocks';
import modalMethod from '../methods/modals';
import initialState from '../initialState/modals';

const modals = (state = initialState, action) => produce(state, (draftState) => {
    switch (action.type) {
        case modalActionTypes.SET_MODAL:
        case canvasBlocksActionTypes.SWITCH_LOCK_STRUCTURE:
        case canvasBlocksActionTypes.LOCK_BLOCKS:
            return modalMethod.setModal(draftState, action);
        default:
            return state;
    }
});

export default modals;
